import { gql } from '@apollo/client';

const schema = {
  send: {
    name: 'sendNotificationToUser',
    serviceName: 'unitadmin',
    query: gql`
      mutation sendNotificationToUser(
        $user_ids: [String]
        $title: String!
        $body: String!
        $image: String
        $icon: String
        $zones: [String]
        $click_action: String
        $shop_id: String
        $unit_id: String
        $user_category_id: String
        $to_sub_childs: Int
      ) {
        sendNotificationToUser(
          user_ids: $user_ids
          title: $title
          body: $body
          image: $image
          icon: $icon
          zones: $zones
          click_action: $click_action
          shop_id: $shop_id
          unit_id: $unit_id
          user_category_id: $user_category_id
          to_sub_childs: $to_sub_childs
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
